<template>
  <Panel class="intro-y" :title="$t('text.customerInfoSelfImages')">
    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-12 lg:col-span-6">
        <div>
          <CustomerImageUpload
            :label="$t('label.selfie')"
            :value="customer.selfie || ''"
            image-type="selfie"
            :customer-id="customer.id"
            :disabled="disabled"
          />
        </div>
      </div>
      <div class="col-span-12 lg:col-span-6">
        <div>
          <CustomerImageUpload
            :label="$t('label.image')"
            :value="customer.image || ''"
            image-type="image"
            :customer-id="customer.id"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>
  </Panel>
</template>

<script>
import Panel from '@/components/ui/Panel';
import CustomerImageUpload from '@/components/customer/CustomerImageUpload';

export default {
  props: {
    customer: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Panel,
    CustomerImageUpload,
  },
};
</script>
